import { render } from "./DashboardMessageBellNotification.vue?vue&type=template&id=3990f506"
import script from "./DashboardMessageBellNotification.vue?vue&type=script&lang=js"
export * from "./DashboardMessageBellNotification.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DashboardMessageBellNotification.vue"]])

export default __exports__